import { PATHS } from '@client/routes';
import { ChallengeDetailsModelData } from '../model/ChallengeDetails.model';
import { Breadcrumb } from '../view/components/common/Breadcrumbs';
import { Submission } from '../model/Challenges.types';
import { getCSV } from '../../promotions/model/csv';

export const toBreadcrumbs = (c: ChallengeDetailsModelData): Breadcrumb[] => {
  const isOTP = c.programType === 'otp';
  return [
    {
      name: isOTP ? 'One-Time Purchases' : 'Subscriptions',
      url: isOTP
        ? PATHS.PURCHASES(c.creatorId)
        : PATHS.SUBSCRIPTIONS(c.creatorId),
    },
    {
      name: c.programName,
      url: PATHS.PROGRAM_EDIT(c.programId, c.creatorId, 'challenges'),
    },

    { name: 'Submissions' },
  ];
};

export type SubmissionCSVRow = {
  ID: string;
  Name: string;
  Email: string;
  'Instagram Handle': string;
  'Phone Number': string;
  Goals: string;
  'Before Allow Repost': string;
  'Before Photos': string;
  'After Allow Repost': string;
  'After Photos': string;
  Shortlisted: string;
  'Is Subscribed?': string;
  'Start Submission Date (UTC)': string;
  'End Submission Date (UTC)': string;
};

function mapSubmissionToCsvRow(submission: Submission): SubmissionCSVRow {
  return {
    ID: submission.submissionId,
    Name: submission.username || '',
    Email: submission.email || '',
    'Instagram Handle': submission.instagram || '',
    'Phone Number': submission.phoneNumber || '',
    Goals: submission.goal || '',

    'Before Allow Repost': submission.repostable ? 'Yes' : 'No',
    'Before Photos': submission.beforeMedia.map((m) => m.url).join(' | '),
    'After Allow Repost': submission.repostable ? 'Yes' : 'No',
    'After Photos': submission.afterMedia.map((m) => m.url).join(' | '),

    Shortlisted: submission.isFav ? 'Yes' : 'No',
    'Is Subscribed?': submission.userStatus === 'Active' ? 'Yes' : 'No',

    'Start Submission Date (UTC)': submission.beforeDate
      ? submission.beforeDate.toISOString()
      : '',
    'End Submission Date (UTC)': submission.afterDate
      ? submission.afterDate.toISOString()
      : '',
  };
}

function mapSubmissionsToCsvRows(
  submissions: Submission[],
): SubmissionCSVRow[] {
  return submissions.map(mapSubmissionToCsvRow);
}

export function exportCSV(submissions: Submission[], filename: string) {
  return getCSV(mapSubmissionsToCsvRows(submissions), filename);
}
